import React from 'react'

const MarkDownIcon = (): React.ReactElement => (
  <svg className="gb-icon size-4 shrink-0 fill-transparent stroke-current" viewBox="0 0 24 24">
    <title>markdown</title>
    <defs>
      <mask id="markdown-mask" style={{ maskType: 'alpha' }}>
        <image
          href="https://ka-p.fontawesome.com/releases/v7.2.0/svgs/brands/markdown.svg?v=2&token=a463935e93"
          width="100%"
          height="100%"
          preserveAspectRatio="xMidYMid meet"
        />
      </mask>
    </defs>

    <rect width="100%" height="100%" fill="currentColor" mask="url(#markdown-mask)" />
  </svg>
)

export default MarkDownIcon
